















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import _ from 'lodash';
import ServiceAgent from '../services/serviceAgent';
import EventBus from '../services/eventBus';
import Buttons from './shared/BottomButtons.vue';
import MovieRate from '@/enums/movieRate';
import Movie from '@/objects/movie';
import MovieSearchDTO from '@/objects/movieSearchDTO';

const serviceAgent = new ServiceAgent();

@Component({
    components: {
        Buttons,
    },
})
export default class Search extends Vue {
    isLoading = false;

    isMouseLeaved = false;

    items: any = [];

    searchText = '';

    debouncedSearch: any;

    searchFocused = false;

    public imageUrl = 'https://image.tmdb.org/t/p/w500';

    mounted() {
        this.debouncedSearch = _.debounce(this.search, 500);

        this.$watch(
            () => (this.$refs.searchInput as any).isFocused,
            (val) => {
                this.searchFocused = val;
            },
        );

        window.onclick = () => {
            if (this.isMouseLeaved && !this.searchFocused) {
                this.searchText = '';
            }
        };
    }

    @Watch('searchText')
    onSearchTextChanged() {
        if (this.searchText && this.searchText !== '') {
            this.isLoading = true;
            this.debouncedSearch();
        } else {
            this.items = [];
        }
    }

    setMouseLeaved(isMouseLeaved: boolean) {
        this.isMouseLeaved = isMouseLeaved;
    }

    get userId() {
        const result = this.$store.getters.userId;

        return result;
    }

    get userMovies(): Movie[] {
        const result = this.$store.getters.userMovies;

        return result;
    }

    getSnackbarText(movieRate: MovieRate) {
        switch (movieRate) {
        case MovieRate.notLiked:
        case MovieRate.liked: {
            return `Added to 'Viewed' with rate '${MovieRate[movieRate]}'`;
        }
        case MovieRate.addedToWatchlist: {
            return 'Added to WatchList';
        }
        default: {
            return '';
        }
        }
    }

    async rateMovie(movieId: string, movieRate: MovieRate) {
        this.searchText = '';

        await serviceAgent.RateMovie(movieId, this.userId, movieRate)
            .then(() => {
                EventBus.$emit('openSnackbar', { snackbarText: this.getSnackbarText(movieRate), snackbarSuccess: true });

                setTimeout(() => {
                    this.$store.dispatch('setUserMovies');
                }, 1000);
            });
    }

    async search() {
        const self = this;
        const { searchText } = this;

        const movies = await serviceAgent.Search(searchText);

        if (this.searchText !== searchText) return;

        this.items = movies.data.map((m: any): MovieSearchDTO => {
            const result = new MovieSearchDTO(m);
            const intersectedMovies = self.userMovies.filter((um: MovieSearchDTO) => result.Id === um.Id);

            if (intersectedMovies.length > 0) result.MovieRate = intersectedMovies[0].MovieRate;

            return result;
        });

        this.isLoading = false;
    }
}
